import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "applyButton", "message"]
  static values = { validateUrl: String }
  static outlets = ["order-form"]

  onInput() {
    this.messageTarget.classList.add("hidden")
    this.messageTarget.textContent = ""
    if (this.hasOrderFormOutlet) {
      this.orderFormOutlet.clearDiscount()
    }
  }

  async apply() {
    const code = this.inputTarget.value.trim()
    if (!code) return

    const selectedSize = document.querySelector('input[name="order[magnet_size]"]:checked')
    const magnetSize = selectedSize ? selectedSize.value : ""

    const url = new URL(this.validateUrlValue, window.location.origin)
    url.searchParams.set("code", code)
    if (magnetSize) url.searchParams.set("magnet_size", magnetSize)

    this.applyButtonTarget.disabled = true

    try {
      const response = await fetch(url.toString(), {
        headers: { "Accept": "application/json" }
      })
      const data = await response.json()

      this.messageTarget.classList.remove("hidden", "text-green-600", "text-red-600")

      if (data.valid) {
        this.messageTarget.classList.add("text-green-600")
        this.messageTarget.textContent = data.message
        if (this.hasOrderFormOutlet) {
          this.orderFormOutlet.applyDiscount(data)
        }
      } else {
        this.messageTarget.classList.add("text-red-600")
        this.messageTarget.textContent = data.message
        if (this.hasOrderFormOutlet) {
          this.orderFormOutlet.clearDiscount()
        }
      }
    } catch {
      this.messageTarget.classList.remove("hidden")
      this.messageTarget.classList.add("text-red-600")
      this.messageTarget.textContent = "Could not validate code. Please try again."
    } finally {
      this.applyButtonTarget.disabled = false
    }
  }
}
